const vueTooltip = {
	install(Vue, options) {
		Vue.directive('tooltips-enabled', {
			bind(el, binding) {
				if (binding.value.title) {
					el.setAttribute('data-toggle', 'tooltip');
					el.setAttribute('data-placement', 'top');
					el.setAttribute('title', binding.value.title);
				}
			},
			inserted(el, binding) {
				Vue.nextTick(function () {
					window.$(el)
						.tooltip({
							html: true,
							delay: {
								show: 300,
								hide: 0
							}
						});
					if (!binding.value.active) {
						window.$(el).tooltip('disable');
					}
				})

			},
			update(el, binding) {
				if (!binding.value.active) {
					window.$(el).tooltip('hide').tooltip('disable');
				}
				else {
					window.$(el).tooltip('enable');
				}
			}
		});
	}
};
export default vueTooltip;

// then can be used in the vue component
// import MyPlugin from './vueTooltip.js'
// The plugin is loaded here.
//Vue.use(vueTooltip)



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/components/base/tooltip/vueTooltip.js